const commonFields = [
    { name: 'markingTeamCode', label: 'Code', type: 'text' }
];

const teamsFields = [
    { name: 'title', label: 'Team Name contains', type: 'text' },    
	{ name: 'templateName', label: 'Template', type: 'list', allowEmpty: true },
    { name: 'displayStatus', label: 'Ready for Approval', type: 'list', allowEmpty: true },
	{ name: 'markingMethodCurrentYear', label: 'Marking Method', type: 'list', allowEmpty: true }
];

const scriptDatesFields = [
    { name: 'title', label: 'Team Name contains', type: 'text' },
	{ name: 'markingMethodCurrentYear', label: 'Marking Method', type: 'list', allowEmpty: true },
    { name: 'scriptDeliveryDate', label: 'Delivery Date', type: 'date' },
	{ name: 'scriptReturnDate', label: 'End Date', type: 'date' },
    { name: 'eMarkingStartDate', label: 'E-marking start date', type: 'date' },
	{ name: 'eMarkingEndDate', label: 'E-marking end date', type: 'date' }
];

const othersFields = [
    { name: 'notes', label: 'Notes', type: 'text' },
];

export { commonFields, teamsFields, scriptDatesFields, othersFields };